import { Injectable } from "@angular/core";
import { ApiService } from "./api";
import { Team } from "model/team";

@Injectable()
export class TeamService {
    constructor(
        private api: ApiService
    ) { }

    async addContestantToTeam(teamId: number, accountId: number) {
        return await this.api.postWithAuth(`${this.api.endpoints.team}/AddContestantToTeam?teamId=${teamId}&contestantId=${accountId}`);
    }

    async removeContestantFromTeam(teamId: number, accountId: number) {
        return await this.api.postWithAuth(`${this.api.endpoints.team}/RemoveContestantFromTeam?teamId=${teamId}&contestantId=${accountId}`);
    }

    async addTeam(team: Team) {
        return await this.api.postWithAuth<Team>(`${this.api.endpoints.team}/CreateTeam`, team);
    }

    async removeTeam(teamId: number) {
        return await this.api.postWithAuth(`${this.api.endpoints.team}/RemoveTeam?teamId=${teamId}`);
    }

    async getTeams(rodeoId: number) {
        return await this.api.getWithAuth<Team[]>(`${this.api.endpoints.team}/GetTeams?rodeoId=${rodeoId}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/team.service.ts